import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { GetMyIncomingInvoiceApprovalsQuerySchema } from "@msuite/utils/schemas";
import type { IncomingInvoiceMyApprovalList } from "@msuite/utils/types";
import { client } from "@/hono";

/**
 * The caller's own approvals — still waiting on them, or decided. The dashboard renders its tile
 * only for a caller with `read IncomingInvoice`, and the page sits behind the same rule in the
 * navigation, so the query needs no gate of its own.
 *
 * @param state - `pending` for what still waits on the caller, `decided` for the rest.
 */
export function useMyIncomingInvoiceApprovals(
	state: GetMyIncomingInvoiceApprovalsQuerySchema["state"],
) {
	/** Query */
	const query = useQuery({
		queryKey: ["incoming-invoice-approvals-mine", state],
		queryFn: async () => {
			const response = await client.incoming_invoices.approvals.mine.$get({ query: { state } });
			const data = await responseHandler(response);
			return data.approvals as IncomingInvoiceMyApprovalList;
		},
	});

	/** Return */
	return { ...query, approvals: query.data ?? [] };
}
